import React from 'react'
import { InclusionHeatMapCard, InclusionHeatMapCardSkeleton } from '@diversioteam/diversio-ds'
import { Link } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { useBenchmarks } from 'hooks/benchmarks/useBenchmarks'
import { useSetPrimaryBenchmark } from 'hooks/benchmarks/useSetPrimaryBenchmark'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { useGetActiveCompanyInformation } from 'hooks/useGetActiveCompany'
import { useGetInclusionHeatmap } from 'hooks/useGetInclusionHeatmap'
import { useTooltips } from 'hooks/tooltips/useTooltips'
import { AppRoute } from 'routing/AppRoute.enum'
import { TooltipId } from 'utils/tooltips.enum'
import TAXONOMIES from 'utils/taxonomies'

const InclusionHeatmapWithoutEB = () => {
    const { companyInformation } = useGetActiveCompanyInformation()
    const { data, isLoading } = useGetInclusionHeatmap()
    const { primaryIndustryBenchmark, queryIndustryBenchmarks } = useBenchmarks()
    const mutationSetPrimaryIndustryBenchmark = useSetPrimaryBenchmark('industry')
    const { getOnboardingButtonProps } = useTooltips()

    const onboardingButtonProps = getOnboardingButtonProps(TooltipId.HomeInclusionHeatmap)

    if (isLoading) {
        return <InclusionHeatMapCardSkeleton data-testid="inclusion-heatmap-card-skeleton" />
    }

    if (!data || data?.length === 0) {
        return null
    }

    return (
        <InclusionHeatMapCard
            results={data}
            titleWrapperProps={{
                component: Link,
                to: generateCompanyURI(AppRoute.AnalyzeInclusion),
            }}
            onSwitchPrimaryIndustry={mutationSetPrimaryIndustryBenchmark.mutate}
            switchOptions={
                queryIndustryBenchmarks.data?.map((industry) => ({
                    label: industry.label,
                    value: industry.uuid,
                })) || []
            }
            switchValue={primaryIndustryBenchmark?.uuid}
            onTrigger={(trigger) => mixpanel.track(TAXONOMIES.HOME_INTERACT_INCLUSION_SUMMARY, { trigger })}
            companyName={companyInformation.name}
            onboardingButtonProps={onboardingButtonProps}
            data-testid="inclusion-heatmap-card"
        />
    )
}

export const InclusionHeatmap = withErrorBoundary(InclusionHeatmapWithoutEB, {})
